module.exports = {"230804198":"前进区镇直辖","230804579":"前进区农垦"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230804.json
// module id = 701
// module chunks = 0